import { defineStore } from "pinia";

import useLocalStorage from "@/composables/storage/useLocalStorage.js";

const { checkLocalStorage, bindLocalStorage } =
  useLocalStorage();

export const useNFTDataStore = defineStore({
    id: "nftData",
    state: () => ({
        nftData: {
            name: null,
            collection: null,
            image: null,
            video: null,
            nftId: null,
        }
    }),
    actions: {
        setNftData(key, val){
            this.nftData[key] = val;
            bindLocalStorage("nftData", this.nftData);
        },
        setNFTDataFromLocalStorage() {
            this.nftData = checkLocalStorage("nftData", this.nftData);
        }
    },
    getters: {
        getNftData(store) {
            return store.nftData;
        }
    }
});